import { render, staticRenderFns } from "./orderPageAddr.vue?vue&type=template&id=656614e8&scoped=true"
import script from "./orderPageAddr.vue?vue&type=script&lang=js"
export * from "./orderPageAddr.vue?vue&type=script&lang=js"
import style0 from "./orderPageAddr.vue?vue&type=style&index=0&id=656614e8&prod&lang=scss"
import style1 from "./orderPageAddr.vue?vue&type=style&index=1&id=656614e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656614e8",
  null
  
)

export default component.exports